import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ActCreators } from '../redux/bindActionCretor';
import HomePageQuickLinksList from '../component/Mobile/HomePageQuickLinksList';
import PersonalizedWelcomeMessage from '../component/Mobile/PersonalizedWelcomeMessage';
import PlusIcon from '../icons/plusicon';

class HomePageQuickLinks extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activetab: 0,
        };
        this.quickLinksRef = React.createRef();
    }

    render() {
        const { activetab } = this.state;
        const tabs = ['Homepage', 'Quick Links'];

        return (
            <React.Fragment>
                <div className="right_side_wrapper">
                    <ul className="fpg_admin_tab disp_flex small_list_tab">
                        {tabs.map((label, index) => {
                            const isQuickLinksActive = index === 1 && activetab === 1;
                            return (
                                <li
                                    key={index}
                                    className={activetab === index ? 'active' : ''}
                                    onClick={() => this.setState({ activetab: index })}
                                >
                                    <p className="uppercase">
                                        <div className={`sd_homepage_tab_label${isQuickLinksActive ? ' sd_homepage_tab_label_active' : ''}`}>
                                            {label}
                                        </div>
                                        {isQuickLinksActive && (
                                            <span
                                                className="add_icon d_flex"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.quickLinksRef.current && this.quickLinksRef.current.openAddPopup();
                                                }}
                                            >
                                                <PlusIcon />
                                            </span>
                                        )}
                                    </p>
                                </li>
                            );
                        })}
                    </ul>

                    {activetab === 0 && (
                        <PersonalizedWelcomeMessage />
                    )}

                    {activetab === 1 && (
                        <HomePageQuickLinksList ref={this.quickLinksRef} />
                    )}
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => bindActionCreators(ActCreators, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(HomePageQuickLinks);
